








import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddEquipment extends Vue {
  addEquipment() {
    this.$store.commit("ADD_EQUIPMENT_CLICK");
  }
}
